export default {
  thPaddingBorderedSmall: '8px 12px',
  thPaddingBorderedMedium: '12px 16px',
  thPaddingBorderedLarge: '16px 24px',
  thPaddingSmall: '0',
  thPaddingMedium: '0',
  thPaddingLarge: '0',
  tdPaddingBorderedSmall: '8px 12px',
  tdPaddingBorderedMedium: '12px 16px',
  tdPaddingBorderedLarge: '16px 24px',
  tdPaddingSmall: '0 0 8px 0',
  tdPaddingMedium: '0 0 12px 0',
  tdPaddingLarge: '0 0 16px 0'
};